enum Actions {
  // action types
  CONFIGURE_AXIOS_AUTHENTICATION = 'configureAxiosAuthentication',
  ADD_BODY_CLASSNAME = 'addBodyClassName',
  REMOVE_BODY_CLASSNAME = 'removeBodyClassName',
  ADD_BODY_ATTRIBUTE = 'addBodyAttribute',
  REMOVE_BODY_ATTRIBUTE = 'removeBodyAttribute',
  ADD_CLASSNAME = 'addClassName',
  SET_THEME_MODE_ACTION = 'setThemeModeAction',
  LOGOUT_USER = 'logoutUser',
  CONNECT_AS_USER = 'connectAsUser',
  EXIT_CONNECT_AS = 'exitConnectAs',
  COMPLETE_AUTHENTICATION_AND_RESOLVE_POST_AUTHENTICATION_TARGET = 'completeAuthenticationAndResolvePostAuthenticationTarget',
}

enum Mutations {
  // mutation types
  LOGOUT_CURRENT_USER = 'logoutCurrentUser',
  SET_CLASSNAME_BY_POSITION = 'appendBreadcrumb',
  SET_LAYOUT_CONFIG_PROPERTY = 'setLayoutConfigProperty',
  RESET_LAYOUT_CONFIG = 'resetLayoutConfig',
  OVERRIDE_LAYOUT_CONFIG = 'overrideLayoutConfig',
  OVERRIDE_PAGE_LAYOUT_CONFIG = 'overridePageLayoutConfig',
  SET_THEME_MODE_MUTATION = 'setThemeModeMutation',

  SAVE_LOGGED_USER = 'saveLoggedUser',
  SAVE_CONNECT_AS_USER = 'saveConnectAsUser',
  EXIT_CONNECT_AS_USER = 'exitConnectAsUser',
  // OAuth mutations
}

export { Actions, Mutations }
